import {
    getCalcProgressFromSessionStorage,
    setCalcProgressToSessionStorage
} from '../common/storage.functions';
import { CalculationProgressMessage } from '../websocket/WebsocketWorker.types';
import {
    CalculationResult,
    CalculationStatus
} from './CalculationResult.types';
import { CalcProgress, DEFAULT_PROGRESS } from '../common/Progress.types';
import { STORAGE_CALC_JOB_ID_KEY } from '../common/constants';

export const calculationIsDisabled = (calculationStatus: CalculationStatus) =>
    calculationStatus === 'CALC_DISABLED' ||
    calculationStatus === 'CALC_RUNNING';

export const calculationResultIsOKWithWarningsAndErrors = (
    calculationStatus: CalculationStatus
) =>
    calculationStatus === 'CALC_RES_OK' ||
    calculationStatus === 'CALC_RES_OK_WITH_WARNINGS' ||
    calculationStatus === 'CALC_RES_OK_WITH_ERRORS';

export const getCalculationStatusFromResult = (
    calculationResult:
        | Pick<CalculationResult, 'resultValues' | 'status' | 'warnings'>
        | undefined
) => {
    if (!calculationResult?.status) {
        return 'CALC_NEEDS_REFRESH';
    }

    return calculationResult.status;
};

export const calculationProgressHandler = (
    message: CalculationProgressMessage
) => {
    const jobId = sessionStorage.getItem(STORAGE_CALC_JOB_ID_KEY);
    if (message.jobId !== jobId) {
        return;
    }

    const currentCalcProgress =
        getCalcProgressFromSessionStorage() ?? DEFAULT_PROGRESS;

    const currentStep: number = message?.step?.index;
    const totalSteps: number = message?.lastStep;
    const percent: number = Math.round((currentStep / totalSteps) * 100);
    const oldPercent = currentCalcProgress.percent ?? 0;
    const newCalcProgress: CalcProgress = {
        percent: percent > oldPercent ? percent : currentCalcProgress.percent,
        message: message?.step?.message
    };
    setCalcProgressToSessionStorage(newCalcProgress);
};
